module.exports = __webpack_public_path__ + "static/media/heart_black.094c056c.svg";